import TargetRoleInputBlock from './TargetRoleInputBlock';
import NationalityInputBlock from './NationalityInputBlock';
import EmailInputBlock from './EmailInputBlock';
import PhoneInputBlock from './PhoneInputBlock';

export const FIELD_COMPONENT_MAP = {
  'Target Role': TargetRoleInputBlock,
  Nationality: NationalityInputBlock,
  Phone: PhoneInputBlock,
  'E-mail': EmailInputBlock,
};
